module.exports = __webpack_public_path__ + "static/media/logo-coreau.75c3b159.png";